export default {"src":"/_next/static/media/bsc.9449da68.svg","height":14,"width":14};